import { EventEmitter, ViewContainerRef } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CpxCardInterface } from "src/app/utils/interfaces/new/cpx-card-interface";
import { CpxCardInfoStatus, CpxCardSignature, CpxSessionInterface, CpxTypeEnum } from "src/app/utils/interfaces/new/cpx-session.interface";
import { LectureCarteVitale, CheckVitaleStatus, VitaleInfos } from "src/app/utils/interfaces/new/lecture-carte-vitale";
import { LectureIns } from "src/app/utils/interfaces/new/lecture-ins.interface";
import { CurrentSession } from "./connecteur-dinno/models";

export const dmpTypeConnexionInteropSettingKey = 'dmp_params_content_type_co_inter_setting';
export const insiTypeConnexionInteropSettingKey = 'insi_params_content_type_co_inter_setting';

export enum CardRippedStatus {
  'rippedCard',
  'dmpConnectError'
}

export enum SessionTypeEnum {
  CARTE = 'carte',
  CERT_DMP = 'certificat_dmp',
  CERT_INSI = 'certificat_insi',
}

export enum TypeConnecteurEnum {
  DINNO = 'dinno',
  DMPConnect = 'dmpConnect',
}

export interface CardInfos {
  type: CpxTypeEnum;
  user: string;
  cabinet: string;
}

export enum WirelessModeCardType {
  'CPX',
  'VITALE'
}

export abstract class CpxHandleServiceAbstract {

  cpxCardRipped: EventEmitter<CardRippedStatus>;
  cpxCardTypeEmmitter: EventEmitter<CpxTypeEnum>;
  cpxCardInfos: BehaviorSubject<CardInfos>;

  abstract showCpxModal(view: ViewContainerRef): Promise<{isSessionOpen: boolean}>;
  
  abstract isModalOpen(): boolean;

  abstract lectureVitale(view: ViewContainerRef, slotName?: string): Promise<LectureCarteVitale>;

  abstract checkVitaleStatus(view: ViewContainerRef, slotName?: string): Promise<CheckVitaleStatus | undefined>;

  /** Réponse brute de la dernière lecture de carte Vitale (lectureVitale) */
  abstract getLastVitaleRead(): LectureCarteVitale | undefined;

  /** Informations techniques (dont le numéro de série) de la dernière carte Vitale lue */
  abstract getVitaleInfos(vitaleIndex: number): Promise<VitaleInfos | undefined>;

  /** Vérifie que la carte présente dans le lecteur est celle de la dernière lecture */
  abstract isSameVitaleCard(): Promise<boolean>;

  abstract isWirelessMode(type: SessionTypeEnum): Promise<boolean>;

  abstract updateCpxAuthenticationToken(cardType: WirelessModeCardType, authToken: string): Promise<void>;

  abstract lectureCpxCard(slotName?: string): Promise<CpxCardInterface>;

  abstract readCpx(slotName: string, pinCode: string): Promise<CpxSessionInterface>;

  abstract getCpxSession(view: ViewContainerRef, type?: SessionTypeEnum, connecteur?:TypeConnecteurEnum): Promise<CpxSessionInterface | any | undefined>;

  abstract getPracticeLocationActivity(): Promise<{pinCode?: string, practiceLocationActivity: string, practiceSettingIndice?: number} | undefined>

  abstract getInstance(view: ViewContainerRef, type?: SessionTypeEnum): Promise<any>;

  abstract getCpxCardStatus(view: ViewContainerRef, type?: SessionTypeEnum, connecteur?:TypeConnecteurEnum): Promise<CpxCardInfoStatus>;

  abstract signWithCpx(view: ViewContainerRef, data: string, pincode: string, authSign?: boolean, type?: SessionTypeEnum, connecteur?:TypeConnecteurEnum): Promise<CpxCardSignature>;

  abstract selectPracticeSettingIndice(indice: number): void;

  abstract setPracticeSetting(practiceSetting: any): void;

  /**
   * @deprecated Utiliser InsServiceAbstract.getInsFromVitaleCard, qui applique le choix websocket / API REST.
   */
  abstract getInsFromVitale(view: ViewContainerRef, resourceId: string, vitaleIndex: number): Promise<LectureIns>;

  abstract isSessionOpen(type: SessionTypeEnum, connecteur?:TypeConnecteurEnum): Promise<boolean>;

  abstract closeSession(type: SessionTypeEnum): Promise<void>;

  abstract isESConnexionIndirect(type: SessionTypeEnum) : Promise<boolean>;

  abstract isErrorEndSession(error: any, type: SessionTypeEnum): boolean

  abstract setInsiConnectorIsCreated(type: SessionTypeEnum, connecteur: TypeConnecteurEnum, isCreated?: boolean): void

  abstract setDmpConnectorIsCreated(type: SessionTypeEnum, connecteur: TypeConnecteurEnum, isCreated?: boolean): void
}
